import type { Thumb, DragState } from './scroll-view.types';
import { AxisEnum } from './scroll-view.enum';

export const DEFAULT_AXIS = AxisEnum.Y;

export const DEFAULT_THICKNESS = 6;

export const DEFAULT_TRACK_VISIBILITY_RATIO = 0.4;

export const DEFAULT_MIN_THUMB_SIZE = 24;

export const EMPTY_THUMB: Thumb = {
    size: 0,
    pos: 0,
    visible: false,
};

export const EMPTY_DRAG_STATE: DragState = {
    axis: null,
    startPointer: 0,
    startScroll: 0,
};
